import React from "react";
import PlainEditor from "../../../../../../../merchant/panel/scripts/shared/editor/plainEditor.js";
import { useContentDt } from "../../scripts/useContentDt.js";
export default function MerchantFooter(props) {
    const text = useContentDt(props.text, props.context);
    return (React.createElement("div", { className: "footer-section" },
        React.createElement(PlainEditor, { example: text, update: text, label: "", onChange: () => { }, editable: false })));
}
